/* DECANTS — FX NEXT (JS mínimo): progress bar + glow vars + tilt universal.
   rAF batching, listeners passive, solo pointer fine, pausa con reduced-motion. */
(function(){
  if (window.__dafxNext) return; window.__dafxNext = 1;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = matchMedia('(pointer: fine)').matches;

  /* progress bar */
  if (!reduce){
    var bar=document.createElement('div'); bar.className='dafx-progress'; document.body.appendChild(bar);
    var ticking=false;
    addEventListener('scroll',function(){
      if(ticking) return; ticking=true;
      requestAnimationFrame(function(){
        var h=document.documentElement, p=h.scrollTop/(h.scrollHeight-h.clientHeight||1);
        bar.style.transform='scaleX('+Math.min(1,Math.max(0,p))+')'; ticking=false;
      });
    },{passive:true});
  }

  if (!fine || reduce) return;

  /* glow que sigue el cursor en secciones dark */
  ['.da-hero','.da-bs','.da-faq'].forEach(function(sel){
    document.querySelectorAll(sel).forEach(function(s){
      s.classList.add('dafx-glow');
      s.addEventListener('pointermove',function(e){
        var r=s.getBoundingClientRect();
        s.style.setProperty('--dafx-mx',((e.clientX-r.left)/r.width*100)+'%');
        s.style.setProperty('--dafx-my',((e.clientY-r.top)/r.height*100)+'%');
      },{passive:true});
    });
  });

  /* tilt 3D + especular en cards de producto (grid Horizon + da-card), máx 30 por página */
  var cards=[].slice.call(document.querySelectorAll('.product-card, .da-card')).slice(0,30);
  cards.forEach(function(c){
    if(c.closest('.da-tilt')) return; /* no duplicar el tilt propio de bestsellers */
    c.classList.add('dafx-tilt');
    var raf=null;
    c.addEventListener('pointermove',function(e){
      if(raf) return;
      raf=requestAnimationFrame(function(){
        var r=c.getBoundingClientRect();
        var px=(e.clientX-r.left)/r.width, py=(e.clientY-r.top)/r.height;
        c.style.setProperty('--dafx-ry',((px-.5)*7).toFixed(2)+'deg');
        c.style.setProperty('--dafx-rx',((.5-py)*7).toFixed(2)+'deg');
        c.style.setProperty('--dafx-gx',(px*100).toFixed(1)+'%');
        c.style.setProperty('--dafx-gy',(py*100).toFixed(1)+'%');
        raf=null;
      });
    },{passive:true});
    c.addEventListener('pointerleave',function(){
      c.style.setProperty('--dafx-rx','0deg'); c.style.setProperty('--dafx-ry','0deg');
    },{passive:true});
  });
})();
